package ui.location

import androidx.compose.runtime.*
import androidx.compose.ui.text.style.*
import androidx.compose.ui.unit.*
import common.frontend.api.*
import provider.*
import ssoft.frontend.generated.resources.*
import tk.mallumo.compose.navigation.*
import tk.mallumo.compose.navigation.viewmodel.*
import tools.*
import ui.*
import ui.widget.*


interface LocationListingScope {

    val vmGlobal: GlobalVM
    val vm: LocationListingVM
    val action: (LocationListingVM.Action) -> Unit
    val nav: Navigation
    val login: Io.User
    val args: LocationListingArgs
    val headerSpecs: ListingSpecs<Wrapper.Item>

    companion object {

        private val headerSpecsInCompany = ListingSpecs.create<Wrapper.Item>(
            ListingSpecs.Item(title = Res.string.location_listing__item_id, width = 50.dp, align = TextAlign.Center) { ListingSpecs.trimmedId(it.data.id) },
            ListingSpecs.Item(title = Res.string.location_listing__item_name, width = 200.dp) { it.data.name },
            ListingSpecs.Item(title = Res.string.location_listing__item_devices, width = 80.dp) { it.data.count_device },
        )

        private val headerSpecsAll = ListingSpecs.create<Wrapper.Item>(
            ListingSpecs.Item(title = Res.string.location_listing__item_id, width = 50.dp, align = TextAlign.Center) { ListingSpecs.trimmedId(it.data.id) },
            ListingSpecs.Item(title = Res.string.location_listing__item_name, width = 200.dp) { it.data.name },
            ListingSpecs.Item(title = Res.string.location_listing__item_name_company, width = 200.dp) { it.data.name_company },
            ListingSpecs.Item(title = Res.string.location_listing__item_devices, width = 80.dp) { it.data.count_device },
        )

        @Composable
        fun rememberScope(): LocationListingScope {
            val account = LocalAccountProvider.current
            val nav = LocalNavigation.current
            val args = LocalNavigationArgs.current
            val arg = args.rememberArgs(LocationListingArgs::class)
            val vm = nav.viewModel(LocationListingVM::class, "${arg.companyId}:${arg.showAll}")
            val vmGlobal = globalViewModel(GlobalVM::class)
            val action = LocationListingVM.Action.rememberAction(vm)

            return remember {
                object : LocationListingScope {
                    override val vmGlobal: GlobalVM
                        get() = vmGlobal
                    override val vm: LocationListingVM
                        get() = vm
                    override val action: (LocationListingVM.Action) -> Unit
                        get() = action
                    override val nav: Navigation
                        get() = nav
                    override val login: Io.User
                        get() = account.current!!
                    override val args: LocationListingArgs
                        get() = arg
                    override val headerSpecs: ListingSpecs<Wrapper.Item>
                        get() = if (arg.showAll) headerSpecsAll else headerSpecsInCompany
                }.also {
                    vm.init(it)
                }
            }
        }
    }

    class Wrapper(
        val canAdd: Boolean,
        listing: Io.ListingLocation
    ) : EFieldList<Io.ListingLocation.Item, Wrapper.Item>(
        items = listing.items,
        onBindEntry = { Item(it) }
    ) {
        class Item(
            override val data: Io.ListingLocation.Item,
            override val key: String = data.id.toString(),

            ) : Entry<Io.ListingLocation.Item> {
            private var origin = data.copy()

            val name: EFieldTextString = EFieldTextString(
                property = data::name,
                condition = { it.trim().takeIf { it.isNotEmpty() } },
                onChange = { makeChange() })

            var change by mutableStateOf(false)
                private set

            private fun makeChange() {
                change = when {
                    name.err -> false
                    origin.name != data.name -> true
                    else -> false
                }
            }
        }
    }
}
